import styled from "styled-components";

import Card from "../Card";

export const FlyoutMenuContainer = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  user-select: none;
  cursor: pointer;
`;

export const FlyoutContainer = styled(Card)<{
  anchor: "left" | "right";
  count: number;
}>`
  position: absolute;
  display: flex;
  top: 50%;
  transform: translateY(-50%);
  ${(props: any) => props.anchor}: calc(100% + 8px);
  padding: 4px 8px;
  width: 0;
  opacity: 0;
  transition: opacity 175ms ease-in, width 175ms ease-out;
  overflow-x: hidden;
  pointer-events: none;

  &.visible {
    width: ${(props: any) => props.count * 40}px;
    opacity: 1;
    transition: opacity 175ms ease-out, width 175ms ease-in;
    pointer-events: unset;
  }
`;

export const FlyoutIconWrapper = styled.div`
  margin: 2px;
  padding: 6px;
  border-radius: 4px;
  display: flex;
  transition: background 75ms ease-in-out;

  &:active {
    background: #00000022;
  }
`;
